module.exports = __webpack_public_path__ + "img/casos.778cf096.svg";